<template>
  <div>
    <vs-popup :title="$t('MoreDetails')" :active.sync="showModal">
      <vs-table class="" :data="currentRow" ref="table">
        <vs-tr>
          <vs-td class="p-1">
            {{ $t("Date") }}
          </vs-td>
          <vs-td style="direction: ltr;" class="p-1"
            >{{ currentRow.persianCreateOn }}
          </vs-td>
        </vs-tr>
        <vs-tr>
          <vs-td class="p-1">
            {{ $t("Brand") }}
          </vs-td>
          <vs-td class="p-1"
            >{{
              currentRow.orderProductInfoQuery
                ? currentRow.orderProductInfoQuery.brandInfo
                  ? currentRow.orderProductInfoQuery.brandInfo
                  : "---"
                : "---"
            }}
          </vs-td>
        </vs-tr>
        <vs-tr>
          <vs-td class="p-1">
            {{ $t("GenericProduct") }}
          </vs-td>
          <vs-td class="p-1"
            >{{
              currentRow.orderProductInfoQuery
                ? currentRow.orderProductInfoQuery.genericProductInfo
                  ? currentRow.orderProductInfoQuery.genericProductInfo
                  : "---"
                : "---"
            }}
          </vs-td>
        </vs-tr>
      </vs-table>
    </vs-popup>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    show: { default: false },
    currentRow: {}
  },
  data() {
    return {};
  },
  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function() {
        this.$emit("finish");
      }
    }
  },
  methods: {}
};
</script>
